import React from 'react';
import { Settings as SettingsIcon, Shield, Bell, Database, Globe } from 'lucide-react';

export const Settings = () => {
  return (
    <div className="max-w-4xl mx-auto space-y-10">
      <div>
        <h1 className="text-3xl font-bold text-slate-900 tracking-tight">Configurações</h1>
        <p className="text-slate-500 mt-1 font-medium">Gerencie as preferências do sistema e acessos.</p>
      </div>

      <div className="grid grid-cols-1 gap-6">
        {[
          { icon: Shield, title: 'Segurana e Acesso', desc: 'Gerencie tokens, senhas e chaves de API do Supabase.' },
          { icon: Bell, title: 'Notificações', desc: 'Configure quem recebe alertas de novas emendas publicadas.' },
          { icon: Database, title: 'Exportação de Dados', desc: 'Fça backup completo das emendas e documentos em JSON/CSV.' },
          { icon: Globe, title: 'Integração Site', desc: 'Ajuste como as emendas são exibidas no portal público.' },
        ].map((item, idx) => (
          <div key={idx} className="bg-white p-8 rounded-[2.5rem] border border-slate-200 shadow-sm flex items-center gap-6 hover:shadow-md transition-all cursor-pointer group">
            <div className="w-14 h-14 bg-slate-50 text-slate-400 rounded-2xl flex items-center justify-center group-hover:bg-blue-600 group-hover:text-white transition-all transform group-hover:scale-110">
              <item.icon size={24} />
            </div>
            <div className="flex-1">
              <h4 className="text-lg font-bold text-slate-900">{item.title}</h4>
              <p className="text-sm font-medium text-slate-500">{item.desc}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="bg-blue-50 border border-blue-100 p-8 rounded-[2.5rem]">
        <h4 className="text-blue-900 font-bold mb-2">Ambiente de Operação</h4>
        <p className="text-blue-700 text-sm font-medium leading-relaxed">
          Atualmente operando em modo de produção conectado ao Supabase. Todas as alterações feitas neste painel refletirão instantaneamente no site institucional.
        </p>
      </div>
    </div>
  );
};
